// sentry-global-error.handler.ts
import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import * as Sentry from '@sentry/angular';

@Injectable()
export class SentryGlobalErrorHandler implements ErrorHandler {
  // Reaproveita a implementação padrão do Sentry
  private readonly sentryHandler = Sentry.createErrorHandler({
    showDialog: false,
  }) as ErrorHandler;

  handleError(error: unknown): void {
    if (error instanceof HttpErrorResponse) {
      // se quiser logar no console:
      // console.warn('Erro HTTP ignorado pelo ErrorHandler global:', error);

      if (this.isHttpStatusIgnored(error)) {
        console.info(`[SentryGlobalErrorHandler] Ignored - ${error.message}`);
        return;
      }
    }

    const ignoredErrorRegexes = [
      /failed to fetch dynamically imported module/i,
      /module script failed/i,
      /recaptcha/i,
      /timeout/i,
      /abort due to cancellation of share/i,
      /aborterror: share canceled/i
    ];

    const fullMessage = this.extractErrorMessage(error);
    if (ignoredErrorRegexes.some(regex => regex.test(fullMessage))) {
      console.info(`[SentryGlobalErrorHandler] Ignored - ${fullMessage}`);
      return;
    }


    this.sentryHandler.handleError(error);
  }


  isHttpStatusIgnored(error: unknown): boolean {
    if (error instanceof HttpErrorResponse && error.status < 200) {
      return true;
    }
    const anyErr = error as any;
    return anyErr?.status === 0 && anyErr?.name === 'HttpErrorResponse';
  }

  /**
   * Extracts a meaningful message from different error shapes: Error, string,
   * HttpErrorResponse, or generic objects.
   */
  private extractErrorMessage(error: unknown): string {
    if (!error) return '';

    // Plain string
    if (typeof error === 'string') {
      return error;
    }

    // Standard Error (most runtime errors will be here)
    if (error instanceof Error) {
      return `${error.name}: ${error.message}`;
    }

    // HttpErrorResponse (in case something escapar dessa verificação antes)
    if (error instanceof HttpErrorResponse) {
      const msg = error.message || error.statusText || '';
      return `HttpErrorResponse ${error.status} ${msg}`.trim();
    }

    // Fallback for plain object with message
    const anyErr = error as any;
    if (typeof anyErr.message === 'string') {
      return anyErr.message;
    }

    // Last fallback: toString on the object
    try {
      return String(error);
    } catch {
      return '';
    }
  }
}
